const CONSOLE_LOG_ROLES = ['site_admin', 'super_admin', 'it'];

export function isConsoleLogAllowedEmail(
  userDetails: { consoleLogEmailAllowed?: boolean } | null | undefined
): boolean {
  return userDetails?.consoleLogEmailAllowed === true;
}

export function hasConsoleLogRole(
  userDetails: { role_name?: string } | null | undefined,
  roleType?: string | null
): boolean {
  const role = `${userDetails?.role_name || roleType || ''}`.trim().toLowerCase();
  return CONSOLE_LOG_ROLES.includes(role);
}

export function canAccessConsoleLog(
  userDetails: { role_name?: string; consoleLogEmailAllowed?: boolean } | null | undefined,
  roleType?: string | null
): boolean {
  return isConsoleLogAllowedEmail(userDetails) || hasConsoleLogRole(userDetails, roleType);
}
